require('./i18n')
require('../components');
